import { NgModule } from '@angular/core';
import { MsTableOldComponent } from './ms-table-old.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';
import { MsInputTextModule } from '../ms-input-text/ms-input-text.module';
import { MsInputSwitchModule } from '../ms-input-switch/ms-input-switch.module';

@NgModule({
	declarations: [MsTableOldComponent],
	imports: [SharedLibsModule, MsButtonModule, MsInputTextModule, MsInputSwitchModule],
	exports: [MsTableOldComponent],
	providers: [],
})
export class MsTableOldModule {}
